import { AppLayout } from "@cloudscape-design/components-themed";
import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import SideNav from "./components/layouts/SideNav";
import Header from "./components/layouts/Header";
import PageHeader from "./components/layouts/PageHeader";
import Notifications from "./features/error/Notifications";
import HelpPanel from "./components/layouts/HelpPanel";
import { useAppSelector, useAppDispatch } from "./app/hook";
import { closeHelpPanel } from "./components/layouts/help-panel-slice";
import { rememberLocation } from "./features/authentication/location-slice";
import { getUserOrSignIn } from "./utils/user";
import { useGetAuthQuery, useGetCodeListQuery } from "./features/api";
import { useSessionMonitor } from "./hooks/useSessionMonitor";

interface AppProps {
  children: React.ReactNode;
  title: string;
}

const App = ({ children, title }: AppProps) => {
  // セッション監視
  useSessionMonitor();

  // 認証情報を取得
  useGetAuthQuery();

  // 画面表示用のコードリスト取得
  useGetCodeListQuery();

  const navigate = useNavigate();
  const hide = useAppSelector((state) => state.helpPanel.hide);
  const open = useAppSelector((state) => state.helpPanel.open);
  // ヘルプパネルを閉じる制御
  const dispatch = useAppDispatch();
  const onChange = function () {
    if (open) {
      dispatch(closeHelpPanel());
    }
  };

  /**
   * ユーザ取得できない場合signIn画面へ遷移
   * ユーザ情報取得
   */
  useEffect(() => {
    dispatch(rememberLocation(window.location.pathname));
    getUserOrSignIn(navigate);
  }, [dispatch, navigate]);

  return (
    <>
      <Header />
      <AppLayout
        contentType="table"
        contentHeader={<PageHeader title={title}></PageHeader>}
        content={children}
        maxContentWidth={Number.MAX_VALUE}
        navigation={<SideNav />}
        tools={<HelpPanel />}
        toolsHide={hide}
        toolsOpen={open}
        notifications={<Notifications />}
        stickyNotifications
        onToolsChange={onChange}
      />
    </>
  );
};

export default App;
